import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { checkTokenValidation } from "../auth/tokenReq";

type getProfileReqPropType = {};

export const getProfileReq = async (
  data?: getProfileReqPropType,
  cancleProfileToken?: any
) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": profileReq->getProfileReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.profileKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = {
      firstName: resData?.user?.firstName || "",
      lastName: resData?.user?.lastName || "",
      designation: resData?.user?.designation || "",
      workLocation: resData?.user?.workLocation || "",
      companyID: resData?.user?.companyID || "",
      userID: resData?.user?.userID || "",
      email: resData?.user?.email || "",
      mobile: resData?.user?.mobile || "",
      role: resData?.user?.role || "",
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
